import { StatusInfo } from "../common/Status";
import { FulfillmentStatus } from "./types";

export function getFulfillmentStatusInfo(status: FulfillmentStatus): StatusInfo {
	const map: Record<FulfillmentStatus, StatusInfo> = {
		pending: { text: 'Paquete listo', class: 'warning', actionText: '' },
		shipped: { text: 'Enviado', class: 'warning', actionText: 'Enviado' },
		delivered: { text: 'Entregado', class: 'success', actionText: 'Entregado' },
		cancelled: { text: 'Cancelado', class: 'danger', actionText: 'Cancelado' },
	};

	return map[status] ?? { text: String(status), class: 'secondary' };
}